import { _t } from '@/locale';

export const ANY_AMPLOYEE = {
  id: 0,
  about: { name: _t('anyEmployee'), jobTitle: _t('availableAllEmployees') },
} as const;
